import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './CancellableContinuationImpl.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { EmptyCoroutineContext_instance2zr761y43akub as EmptyCoroutineContext_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineStart_DEFAULT_getInstancem736nlr0ekl as CoroutineStart_DEFAULT_getInstance } from './CoroutineStart.mjs';
import { asyncz02dsa2nb2zt as async } from './Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function await_0(_this__u8e3s4, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  var cont = cancellable;
  var tmp = (it) => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.tc(tmp$ret$0);
    return Unit_instance;
  };
  _this__u8e3s4.then(tmp, (it) => {
    var tmp0 = cont;
    var tmp0_elvis_lhs = it instanceof Error ? it : null;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = tmp0_elvis_lhs == null ? Exception().de('Non-Kotlin exception ' + it.toString()) : tmp0_elvis_lhs;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.tc(tmp$ret$2);
    return Unit_instance;
  });
  return cancellable.my();
}
function promise(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  return asPromise(async(_this__u8e3s4, context, start, block));
}
function asPromise(_this__u8e3s4) {
  var promise = new Promise((resolve, reject) => {
    _this__u8e3s4.hx((it) => {
      var e = _this__u8e3s4.dy();
      var tmp;
      if (!(e == null)) {
        tmp = reject(e);
      } else {
        tmp = resolve(_this__u8e3s4.xy());
      }
      return Unit_instance;
    });
    return Unit_instance;
  });
  // Inline function 'kotlin.js.asDynamic' call
  promise.deferred = _this__u8e3s4;
  return promise;
}
//region block: exports
export {
  await_0 as awaitopqeg9l1dqx0,
  promise as promise1ky6tawqaxbt4,
};
//endregion

//# sourceMappingURL=Promise.mjs.map
